import {
    faBitcoinSign,
    faBriefcase,
    faChartLine,
    faCommentDots,
    faCreditCard,
    faEnvelope,
    faGear,
    faGears,
    faSignOutAlt,
    faTerminal,
    faTimes,
    faUsers,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link, useNavigate } from 'react-router-dom';
import { clearSession, doLogout } from '../../services/AuthService';
import SideBarGroup from './SideBarGroup';
import SideBarItem, { ActivePathsProvider } from './SideBarItem';

// Every destination rendered below; SideBarItem uses it to pick the best match
// for the current path (so nested screens keep their section selected).
const NAV_PATHS = [
    '/dashboard',
    '/users',
    '/plans',
    '/upgrade-requests',
    '/feedback',
    '/settings',
    '/emails',
    '/symbols',
    '/logs',
    '/',
];

function SideBar() {
    const navigate = useNavigate();

    function cleanAndRedirect() {
        clearSession();
        navigate('/');
    }

    function onLogoutClick(event) {
        doLogout()
            .then(response => cleanAndRedirect())
            .catch(error => {
                console.error(error);
                cleanAndRedirect();
            });
    }

    return (
        <nav
            id="sidebarMenu"
            className="sidebar d-lg-block bg-gray-800 text-white collapse"
            datasimplebar="true"
        >
            <div className="sidebar-inner px-4 pt-3">
                <div className="user-card d-flex d-md-none align-items-center justify-content-between justify-content-md-center pb-4">
                    <div className="collapse-close d-md-none">
                        <a
                            href="#sidebarMenu"
                            data-bs-toggle="collapse"
                            data-bs-target="#sidebarMenu"
                            aria-controls="sidebarMenu"
                            aria-expanded="true"
                            aria-label="Toggle navigation"
                        >
                            <FontAwesomeIcon
                                icon={faTimes}
                                className="icon icon-xs my-vb-icon"
                            />
                        </a>
                    </div>
                </div>
                <ActivePathsProvider paths={NAV_PATHS}>
                    <ul className="nav flex-column pt-3 pt-md-0">
                        <li className="nav-item">
                            <Link
                                to="/dashboard"
                                className="nav-link d-flex align-items-center"
                            >
                                <span className="sidebar-icon">
                                    <img
                                        src="/img/favicon/favicon-32x32.png"
                                        height="32"
                                        width="32"
                                        alt="Argos TraderBot Logo"
                                    />
                                </span>
                                <span className="mt-1 ms-1 sidebar-text">
                                    Argos TraderBot
                                </span>
                            </Link>
                        </li>
                        <li
                            role="separator"
                            className="dropdown-divider mt-4 mb-3 border-gray-700"
                        ></li>
                        <SideBarItem to="/dashboard" text="Dashboard">
                            <FontAwesomeIcon
                                icon={faChartLine}
                                className="icon icon-xs me-2 my-vb-icon"
                            />
                        </SideBarItem>
                        <SideBarItem to="/users" text="Users">
                            <FontAwesomeIcon
                                icon={faUsers}
                                className="icon icon-xs me-2 my-vb-icon"
                            />
                        </SideBarItem>
                        <SideBarItem to="/plans" text="Plans">
                            <FontAwesomeIcon
                                icon={faBriefcase}
                                className="icon icon-xs me-2 my-vb-icon"
                            />
                        </SideBarItem>
                        <SideBarItem
                            to="/upgrade-requests"
                            text="Upgrade Requests"
                        >
                            <FontAwesomeIcon
                                icon={faCreditCard}
                                className="icon icon-xs me-2 my-vb-icon"
                            />
                        </SideBarItem>
                        <SideBarItem to="/feedback" text="Feedback">
                            <FontAwesomeIcon
                                icon={faCommentDots}
                                className="icon icon-xs me-2 my-vb-icon"
                            />
                        </SideBarItem>
                        <SideBarGroup
                            id="submenu-settings"
                            text="Settings"
                            paths={[
                                '/settings',
                                '/emails',
                                '/symbols',
                                '/logs',
                            ]}
                            icon={
                                <FontAwesomeIcon
                                    icon={faGear}
                                    className="icon icon-xs me-2 my-vb-icon"
                                />
                            }
                        >
                            <SideBarItem to="/settings" text="System">
                                <FontAwesomeIcon
                                    icon={faGears}
                                    className="icon icon-xs me-2 my-vb-icon"
                                />
                            </SideBarItem>
                            <SideBarItem to="/emails" text="Emails">
                                <FontAwesomeIcon
                                    icon={faEnvelope}
                                    className="icon icon-xs me-2 my-vb-icon"
                                />{' '}
                            </SideBarItem>
                            <SideBarItem to="/symbols" text="Symbols">
                                <FontAwesomeIcon
                                    icon={faBitcoinSign}
                                    className="icon icon-xs me-2 my-vb-icon"
                                />{' '}
                            </SideBarItem>
                            <SideBarItem to="/logs" text="Logs">
                                <FontAwesomeIcon
                                    icon={faTerminal}
                                    className="icon icon-xs me-2 my-vb-icon"
                                />{' '}
                            </SideBarItem>
                        </SideBarGroup>
                        <li
                            role="separator"
                            className="dropdown-divider mt-4 mb-3 border-gray-700"
                        ></li>
                        <SideBarItem
                            to="/"
                            text="Logout"
                            onClick={onLogoutClick}
                        >
                            <FontAwesomeIcon
                                icon={faSignOutAlt}
                                className="icon icon-xs me-2 my-vb-icon"
                            />
                        </SideBarItem>
                    </ul>
                </ActivePathsProvider>
            </div>
        </nav>
    );
}

export default SideBar;
